import React from 'react';
import { Box, Container, Paper, Typography } from '@mui/material';

// Neutral catch-all for the Israel patient app. Patients always arrive via a
// specific link (schedule token, ...). Any other/unknown URL lands here.
const IsraelLandingPage: React.FC = () => (
  <Box
    dir="rtl"
    display="flex"
    justifyContent="center"
    alignItems="center"
    minHeight="100vh"
    bgcolor="background.default"
  >
    <Container maxWidth="sm">
      <Paper elevation={0} sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h5" gutterBottom>
          אין כאן דבר
        </Typography>
        <Typography variant="body1" color="text.secondary">
          השתמשו בקישור שנשלח אליכם כדי להמשיך.
        </Typography>
      </Paper>
    </Container>
  </Box>
);

export default IsraelLandingPage;
